import React from 'react';
import { Arbeitsgruppe } from '../types';

interface ArbeitsgruppenPageProps {
    arbeitsgruppen: Arbeitsgruppe[];
    onArbeitsgruppeClick: (id: number) => void;
    myArbeitsgruppenIds: number[];
}

const ArbeitsgruppenPage: React.FC<ArbeitsgruppenPageProps> = ({ arbeitsgruppen, onArbeitsgruppeClick, myArbeitsgruppenIds }) => {
    return (
        <div className="space-y-6">
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {arbeitsgruppen.map((ag) => {
                    const isRegistered = myArbeitsgruppenIds.includes(ag.id);
                    return (
                        <div
                            key={ag.id}
                            onClick={() => onArbeitsgruppeClick(ag.id)}
                            className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer overflow-hidden flex flex-col h-full"
                        >
                            <div className="p-6 flex-grow">
                                <div className="flex justify-between items-start mb-4">
                                    <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm">
                                        {ag.challenge}
                                    </span>
                                    <div className="flex items-center gap-2">
                                        {isRegistered && (
                                            <span className="material-symbols-outlined text-green-700" aria-label="Angemeldet">
                                                person
                                            </span>
                                        )}
                                        <span className="text-xs font-medium px-2.5 py-0.5 rounded bg-gray-100 text-gray-800">
                                            {ag.currentParticipantsCount} / {ag.maxParticipantsCount}
                                        </span>
                                    </div>
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">{ag.name}</h3>

                                <div className="space-y-2 mt-4">
                                    {ag.coach && (
                                        <div className="flex items-center text-sm text-gray-500">
                                            <span className="font-medium mr-2">Coach:</span>
                                            <span>{ag.coach}</span>
                                        </div>
                                    )}
                                    {ag.room && (
                                        <div className="flex items-center text-sm text-gray-500">
                                            <span className="font-medium mr-2">Raum:</span>
                                            <span>{ag.room}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                                <span className="text-primary text-sm font-medium hover:text-primary/80 transition-colors flex items-center">
                                    Details anzeigen
                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ArbeitsgruppenPage;
